import clsx from 'clsx'
import React from 'react'
import type { TPhase } from 'types/classAndPhases'
import type {
  TGeneralToolkit,
  TGeneralToolkitSplitBahanAjar,
  TToolkitType,
} from 'types/toolkit'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

interface TSubjectSelectProps {
  handleFilterChange: (value: 'phase' | 'subject') => void
  selectedSubject: string
  phase: TPhase[]
  activeToolkitType: TGeneralToolkit | TGeneralToolkitSplitBahanAjar
  toolkitType: TToolkitType
  containerClassName?: string
  dropdownClassName?: string
}

const SelectedSubject = ({
  handleFilterChange,
  selectedSubject,
  phase,
  activeToolkitType,
  toolkitType,
  containerClassName,
  dropdownClassName,
}: TSubjectSelectProps) => {
  const isDisableSubjectSelection =
    !phase?.[0] ||
    (phase?.includes('Fondasi') && toolkitType !== 'modul-projek')
  return (
    <span
      className={clsx(
        isDisableSubjectSelection
          ? 'pointer-events-none cursor-not-allowed'
          : '',
        containerClassName || ''
      )}
    >
      <span
        onClick={() => handleFilterChange('subject')}
        className={clsx(
          phase ? '!border-default' : '!border-disabled bg-surface-disabled',
          'flex w-full cursor-pointer justify-between rounded-[4px] !border py-3 px-4',
          dropdownClassName || ''
        )}
      >
        <Text
          color={selectedSubject ? 'default' : 'disabled'}
          className="truncate"
        >
          {selectedSubject ||
            (activeToolkitType === 'modul_projek'
              ? 'Pilih tema'
              : 'Pilih mata pelajaran')}
        </Text>
        <Icon>arrow_drop_down</Icon>
      </span>
    </span>
  )
}

export default SelectedSubject
